import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error/index.js';
import { useEffect, useMemo, useRef } from 'react';
export function useAuthHeadersLink(authenticityToken) {
    const authenticityTokenRef = useRef(authenticityToken);
    useEffect(() => {
        authenticityTokenRef.current = authenticityToken;
    }, [authenticityToken]);
    const authHeadersLink = useMemo(() => new ApolloLink((operation, next) => {
        operation.setContext((context) => (Object.assign(Object.assign({}, context), { credentials: 'same-origin', headers: Object.assign(Object.assign({}, context.headers), { 'X-CSRF-Token': authenticityTokenRef.current }) })));
        return next(operation);
    }), []);
    return authHeadersLink;
}
export function useErrorHandlerLink(onUnauthenticatedRef) {
    const errorHandlerLink = useMemo(() => onError(({ graphQLErrors }) => {
        if (graphQLErrors) {
            if (graphQLErrors.some((err) => (err.extensions || {}).code === 'NOT_AUTHENTICATED')) {
                if (onUnauthenticatedRef === null || onUnauthenticatedRef === void 0 ? void 0 : onUnauthenticatedRef.current) {
                    onUnauthenticatedRef.current();
                }
            }
        }
    }), [onUnauthenticatedRef]);
    return errorHandlerLink;
}
//# sourceMappingURL=ApolloLinkHelpers.js.map